export default {
	props: {
		label: String,
		info: String,
		name: {
			type: String,
			required: true
		},
		placeholder: String,
		required: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text'
		},
		min: String,
		max: String,
		disabled: {
			type: Boolean,
			default: false
		},
		value: null,
		errors: Array
	},
	computed: {
		bind() {
			return {
				id: this.name,
				name: this.name,
				placeholder: this.placeholder,
				type: this.type,
				min: this.min,
				max: this.max,
				disabled: this.disabled
			}
		},
		model: {
			get() {
				return this.value.value
			},
			set(rawValue) {
				if (!this.disabled) {
					const value = this.parseValue(rawValue)
					this.$emit('input', { value, $dirty: false })
				}
			}
		},
		dirty: {
			get() {
				return this.value.$dirty
			},
			set($dirty) {
				this.$emit('input', { ...this.value, $dirty })
			}
		},
		error() {
			if (this.errors && this.errors.length && this.dirty) {
				return this.errors[0]
			}
			return undefined
		},
		wrapper() {
			return {
				name: this.name,
				label: this.label,
				info: this.info,
				error: this.error,
				required: this.required,
				disabled: this.disabled
			}
		}
	},
	methods: {
		parseValue(rawValue) {
			switch (this.type) {
				case 'number':
					return Number(rawValue)
				default:
					return rawValue
			}
		},
		watchField(attach = true) {
			// If ref points to input element, set up blur event
			const { field } = this.$refs
			if (field && !this.disabled) {
				if (attach) field.addEventListener('blur', this.onBlur)
				else field.removeEventListener('blur', this.blur)
			}
		},
		onBlur() {
			this.$nextTick(() => {
				this.dirty = true
			})
		}
	},
	beforeDestroy() {
		this.watchField(false)
	}
}
